import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

const formdatatomap = [
  { title: "Choose post type", name: "type", placeholder: "Choose post type" },
];

const ModalType = ({ formData, setFormData, setModaltype }) => {
  const initialValues = {
    type: formData?.type,
    duration: formData?.duration,
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Project duration is required"),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    setModaltype((state) => !state);
  };

  return (
    <>
      {/* <ModalHeader toggle={() => setModaltype(state => !state)}></ModalHeader> */}
      <button
        onClick={() => setModaltype((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              {}
              {formdatatomap.map((prop, key) => {
                if (prop.name == "type") {
                  return (
                    <div key={key} className="form-group">
                      <h6>{prop.title}</h6>
                      <div className="checkbox-label mb-3">
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="1" />
                          <span className="checkmark">Project</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="2" />
                          <span className="checkmark">Contest</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="3" />
                          <span className="checkmark">Part time job</span>
                        </label>
                      </div>
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
              })}

              {/* <ModalFooter>
                                <Button color="primary" className="next-button"
                                    type="button"
                                    onClick={formik.handleSubmit}
                                > SAVE
                                </Button>
                            </ModalFooter> */}
            </Form>
          )}
        </Formik>
      </ModalBody>
      <div className="modal-footer ">
        <button className="btn">Save</button>
      </div>
    </>
  );
};

export default ModalType;
